export default "assets/images/stries-a072e406.png";